import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { Logo } from 'assets/img';
import {
	Survey1Icon,
	Survey2Icon,
	Survey3Icon,
	Survey4Icon,
	Survey5Icon,
	Survey6Icon,
	CheckWhiteIcon,
	WhatsappSurveyIcon,
	EmailIcon,
	InstagramSurveyIcon,
	CheckGreenIcon
} from 'assets/icons';
import { QuoteService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalSurvey extends React.Component<Props> {

	state = {
		survey: null,
		titles: [],
		contact_info: null,
		values_array: []
	}

	async componentDidMount() {
		let values_array = [];
		for (let i = 1; i <= 6; i++) {
			let icon = '';

			switch(i) {
				case 1:
					icon = Survey1Icon;
				break;

				case 2:
					icon = Survey2Icon;
				break;

				case 3:
					icon = Survey3Icon;
				break;

				case 4:
					icon = Survey4Icon;
				break;

				case 5:
					icon = Survey5Icon;
				break;

				case 6:
					icon = Survey6Icon;
				break;
			}

			values_array.push({
				value: i,
				icon
			});
		}

		await this.setState({
			values_array
		});

		this.load();
	}

	load = async () => {
		const res: any = await QuoteService.admin.getSurvey({
			quote_id: this.props.item?.id
		});
		this.setState({
			visible: true,
			survey: res.survey,
			titles: res.titles || [],
			contact_info: res.contact_info
		});
	}
	
	getResponse = (params: any) => {
		// @ts-ignore
		const value = this.state.survey?.responses.find((i: any) => (i.question_id != null && i.question_id == params.question_id) || (i.subtitle_id != null && i.subtitle_id == params.subtitle_id));

		return value?.response || value?.comments;
	}

	render() {
		const contact_info: any = this.state.contact_info;
		const survey: any = this.state.survey;
		const values_array: any = this.state.values_array;

		return (
			<div id="modal-survey">
				<div className="container-survey">
					<div className="text-center">
						<img src={ Logo } className="logo" />
					</div>
					<p className="code">Nº de Control: { survey?.quote?.number }</p>
					<h3>Control de calidad y servicio</h3>
					<div className="container-title">
						<h4>Datos del cliente</h4>
						<div>
							<p className="value"><strong>Nombre:</strong> { survey?.quote?.user?.full_name }</p>
							<p className="value"><strong>Dirección del servicio:</strong> { survey?.quote?.address }</p>
							<p className="value"><strong>Tipo de servicio:</strong> { survey?.quote?.type?.name }</p>
						</div>
					</div>
					<div className="container-title">
						<h4>Datos de los talentos en limpieza</h4>
						<div>
							{
								survey?.quote?.operators?.map((item: any) => {
									return (
										<div className="row item-operator">
											<div className="col-md-7">
												<p className="value"><strong>Nombre:</strong> { item?.operator?.full_name }</p>
											</div>
											<div className="col-md-5">
												<p className="value"><strong>Nº CI:</strong> { item?.operator?.full_document }</p>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
					{
						this.state.titles.map((item: any, title_index: number) => {
							return (
								<div className="container-title">
									<h4>{ item.name }</h4>
									{
										item?.subtitles.length > 0 && (
											<>
												<table style={{ width: '100%' }}>
													<tr>
														<td style={{ width: '40%' }}>
															<p className="value-subtitle"></p>
														</td>
														{
															values_array.map((item: any) => {
																return (
																	<td style={{ width: '10%' }} className="text-center">
																		<img src={ item.icon } className="survey-icon" />
																	</td>
																)
															})
														}
													</tr>
													{
														item?.subtitles?.map((subtitle: any, index: number) => {
															return (
																<tr>
																	<td style={{ width: '40%' }}>
																		<p className="value-subtitle">{ subtitle?.name }</p>
																	</td>
																	{
																		values_array.map((item: any) => {
																			return (
																				<td style={{ width: '10%' }} className="text-center">
																					<div className={ `check ${ subtitle.value == item.value ? 'active' : '' }` }>
																						{
																							this.getResponse({ subtitle_id: subtitle?.id }) == item.value && (
																								<img src={ CheckGreenIcon } />
																							)
																						}
																					</div>
																				</td>
																			)
																		})
																	}
																</tr>
															)
														})
													}
												</table>
											</>
										)
									}
									{
										item?.questions?.length > 0 && (
											<div>
												<div className="row">
													{
														item?.questions.map((question: any, index: number) => {
															return (
																<>
																	<div className="col-md-6">
																		<p className="value-question">{ question?.name }</p>
																	</div>
																	<div className="col-md-6">
																		<p className="response">{ this.getResponse({ question_id: question?.id }) }</p>
																	</div>
																</>
															)
														})
													}
												</div>
											</div>
										)
									}
								</div>
							)
						})
					}
					<div className="container-title">
						<h4>Observaciones</h4>
						<div>
							<p className="response">{ survey?.comments }</p>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<p className="footer">
								<img src={ WhatsappSurveyIcon } className="info-icon" />
								{ contact_info?.whatsapp }
							</p>
						</div>
						<div className="col-md-4">
							<p className="footer">
								<img src={ InstagramSurveyIcon } className="info-icon" />
								{ contact_info?.instagram.replace('https://www.instagram.com/','@').replace('/','') }
							</p>
						</div>
						<div className="col-md-4">
							<p className="footer">
								<img src={ EmailIcon } className="info-icon" />
								{ contact_info?.email }
							</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalSurvey;